
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './../IAppForm'
import { ApplicationModule } from '@/store'

import EmploymentDto from '../../../types/dto/employmentDto'
import CFInput from '../../inputs/CFInput'

	@Component({
	  name: 'EmploymentLength'
	})
export default class EmploymentLength extends Vue implements IAppForm {
		// #region  Props
		@Prop() employment!: EmploymentDto;
		@Prop() wizardIndex!: number;
		@Prop({ default: false }) lowDetail!: boolean;
		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		monthCount = 0;
		years: number | null = null;
		months: number | null = null;

		isValid = true;
		showMonthError = false;
		showYearError = false;
		showError = false;

		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit')
		}

		previous () {
		  this.$emit('previous')
		}

		validate () {
		  this.showMonthError = !(this.$refs.monthsAtEmployer as unknown as CFInput).validate()
		  this.showYearError = !(this.$refs.yearsAtEmployer as unknown as CFInput).validate()
		  this.showError = this.showMonthError || this.showYearError

		  this.setMonthCount()

		  if (this.monthCount < 1) {
		    this.showError = true
		    this.showMonthError = true
		    this.showYearError = true
		  }

		  if (this.showError) {
		    return false
		  }

		  return true
		}

		input () {
		  this.showError = false
		}

		async setMonthCount () {
		  let count = 0

		  count += Number(this.years ? this.years * 12 : 0)
		  count += Number(this.months ? this.months : 0)

		  this.monthCount = count
		}

		clearErrors () {
		  this.showError = false
		  this.showMonthError = false
		  this.showYearError = false;
		  (this.$refs.monthsAtEmployer as unknown as CFInput).valid = true;
		  (this.$refs.yearsAtEmployer as unknown as CFInput).valid = true
		}

		// #endregion

		// #region Computed

		get editingEmploymentIndex () {
		  return ApplicationModule.editingEmploymentIndex ?? -1
		}

		get cssClass () {
		  return this.hasErrors ? 'error' : ''
		}

		get hasErrors () {
		  return this.showMonthError || this.showYearError || this.monthCount < 1
		}

		// #endregion

		// #region Watches

		@Watch('editingEmploymentIndex')
		changeEmployment () {
		  this.employment = ApplicationModule.editingEmployment
		  this.clear()
		}

		@Watch('employment.employmentLevel', { deep: true, immediate: true })
		clear () {
		  setTimeout(() => {
		    this.clearErrors()

		    if (this.employment.yearsAtEmployer && this.employment.yearsAtEmployer >= 0) {
		      this.years = this.employment.yearsAtEmployer
		    } else {
		      this.years = null
		    }
		    if (this.employment.monthsAtEmployer && this.employment.monthsAtEmployer >= 0) {
		      this.months = this.employment.monthsAtEmployer
		    } else {
		      this.months = null
		    }
		  }, 100)
		}

		@Watch('years')
		updateYears () {
		  setTimeout(() => {
		    this.validate()

		    if (this.years) {
		      this.employment.yearsAtEmployer = this.years
		    } else {
		      this.employment.yearsAtEmployer = 0
		    }
		  }, 1)
		}

		@Watch('months')
		updateMonths () {
		  setTimeout(() => {
		    this.validate()

		    if (this.months) {
		      this.employment.monthsAtEmployer = this.months
		    } else {
		      this.employment.monthsAtEmployer = 0
		    }
		  }, 1)
		}
		// #endregion
}
